export default __webpack_public_path__ + "static/laura_rus_1500-64d3b7d847a5985e455248cc155c364a.jpg";